export enum MyRewardsTabType {
  RewardHistory = 'rewardHistory',
  ActivityLog = 'activityLog',
}
